import { createActions } from 'redux-actions';

export default createActions({
  AUTH_START: undefined,
  AUTH_SUCCESS: undefined,
  AUTH_FAIL: undefined,
  LOGOUT: undefined,
  LOGOUT_FAIL: undefined,
});
